import React, { useEffect, useRef } from "react";
import { AssessmentReportPDF } from "../resources";
import { Footer } from "../components";
import * as pdfjs from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function PAR() {
  const parentRef = useRef(null);

  useEffect(() => {
    let isCancelled = false;

    async function renderPdf() {
      try {
        const loadingTask = pdfjs.getDocument(AssessmentReportPDF);
        const pdf = await loadingTask.promise;
        if (isCancelled) return;

        if (parentRef.current) parentRef.current.innerHTML = "";

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          if (isCancelled) return;

          const page = await pdf.getPage(pageNum);

          // Include page rotation — helps with some PDFs
          const viewport = page.getViewport({
            scale: 1.2,
            rotation: page.rotate || 0,
          });

          const canvas = document.createElement("canvas");
          canvas.id = `pdf-page-${pageNum}`;
          // Make it obvious if it's rendered but hidden
          canvas.style.display = "block";
          canvas.style.background = "#fff"; // PDF pages can be transparent
          canvas.style.margin = "0 auto 16px";

          const ctx = canvas.getContext("2d");
          canvas.width = Math.ceil(viewport.width);
          canvas.height = Math.ceil(viewport.height);

          console.log(`Rendering p${pageNum}/${pdf.numPages} -> ${canvas.width}x${canvas.height}`);

          const renderTask = page.render({ canvasContext: ctx, viewport });
          await renderTask.promise;

          if (isCancelled) return;
          parentRef.current?.appendChild(canvas);
        }

        // Ensure we’re scrolled to top so page 1 is visible
        parentRef.current?.scrollTo?.(0, 0);
      } catch (err) {
        console.error("PDF render error:", err);
      }
    }

    renderPdf();
    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <>
      <main className="single-par">
        <section className="section section--grey section--full-width section--report">
          <div className="container">
            <div
              className="pdf-report"
              ref={parentRef}
              style={{
                // TEMP: make sure we can scroll and nothing is clipped
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
